import clsx from "clsx";
import React from "react";
import { footnotesType } from "../../../common/types/search/search";

interface FootnotesContainerProps {
	footnotes?: footnotesType;
	restricted?: boolean;
}

export function FootnotesContainer({
	footnotes,
	restricted,
}: FootnotesContainerProps) {
	const classes = clsx("footnotes", { restricted });

	if (!footnotes || !footnotes.hasFootnotes()) {
		return null;
	}

	return (
		<div className={classes}>
			{footnotes.toArray().map((footnote) => {
				return (
					<p key={footnote.key}>
						<span className="footnotes__marker">
							<sup>{footnote.marker}</sup>
						</span>{" "}
						{footnote.description}
					</p>
				);
			})}
		</div>
	);
}
